<div class="position-fixed sticky-top w-100" style="left: 0; right: 0; z-index: 15000;">
  <app-alerting></app-alerting>
</div>
<app-overview [overviewFilters]="filters.overviewFilters" [searchFunction]="searchTermFunction" (resultsFound)="renderRecords($event, false)"
  [isEmpty]="isEmpty" [facetNameFormatter]="nameFormatter" [facetsLoading]="facetsLoading" [facets]="facets" [otherFacets]="otherFacets"
  (filtersCleared)="clearFilters($event)" (facetFiltersChanged)="facetFiltersChanged($event)"
  (loadNextPage)="loadNextPage()" [quickViews]="quickViews"
  [allSelectable]="anyRecordSelectable" [(selectionState)]="allSelectionState"
  [specificFacetFiltersTemplate]="specificFacetFilters"
  [virtualScroll]="true" [itemSize]="65" [virtualData]="data"
  [virtualItemTemplate]="consignmentItemTemplate" [virtualTrackBy]="trackByRecord">
  <app-overview-navigation-tabs class="tabs" [items]="cargoNavigationTabs"></app-overview-navigation-tabs>
  <app-overview-navigation-tabs [mobile]="true" class="tabs-mobile d-flex align-items-center" [items]="cargoNavigationTabs"></app-overview-navigation-tabs>
  <div class="header-bar d-flex">
    @if (allowedToAddAnything()) {
      <div class="d-none ms-3 d-lg-block center-bar col-auto ps-0 dropdown">
        <button class="btn btn-primary text-decoration-none" data-bs-toggle="dropdown">
          <i class="me-xl-2 button-icon fa-light fa-plus"></i>
          <span class="d-none d-xl-inline-block">Create</span>
        </button>
        <ul class="dropdown-menu dropdown-menu-start" style="cursor: pointer">
          @if (utils.allowedToAddConsignment()) {
            <li class="dropdown-item" (click)="createConsignment()">
              New consignment
            </li>
          }
          @if (utils.allowedToAddTranshipment()) {
            <li class="dropdown-item" data-bs-toggle="modal" data-bs-target="#declareTranshipmentContainerConsignment">
              New transhipment (container consignment)
            </li>
            <li class="dropdown-item" data-bs-toggle="modal" data-bs-target="#declareTranshipmentBulkConsignment">
              New transhipment (bulk consignment)
            </li>
          }
        </ul>
      </div>
    }
    @if (appContext.isAdmin() || appContext.isCargoImportViewer()) {
      <div class="d-none ms-3 d-lg-block center-bar col-auto ps-0 dropdown">
        <button class="btn btn-link link-primary text-decoration-none" data-bs-toggle="dropdown">
          <i class="me-xl-2 d-lg-inline-block button-icon fa-light fa-arrow-down-to-line"></i>
          <span class="d-none d-xl-inline-block">Download</span>
        </button>
        <ul class="dropdown-menu dropdown-menu-start" style="cursor: pointer">
          <li class="dropdown-item" (click)="downloadBlDetails()">
            B/L details
          </li>
          <li class="dropdown-item" (click)="downloadMrns()">
            MRNs
          </li>
          <li class="dropdown-item" (click)="downloadClearanceDifferences()">
            Clearance differences
          </li>
          @if (appContext.hasCargoThroughputData()) {
            <li class="dropdown-item" (click)="downloadZhsData()">
              Cargo throughput data
            </li>
          }
        </ul>
      </div>
    }
    <div class="sub-text ms-3 align-items-center d-none d-lg-flex">
      <i class="fa fa-fw fa-light fa-xl fa-file-lines me-1"></i>
      <app-loading-icon [loading]="facetsLoading">
        <span>{{masterConsignmentCount | numberFormat}}</span>
      </app-loading-icon>
    </div>
    <div class="sub-text ms-3 align-items-center d-none d-lg-flex">
      <i class="fa fa-kit fa-fw fa-light fa-xl fa-pb-file-line me-1"></i>
      <app-loading-icon [loading]="facetsLoading">
        <span>{{houseConsignmentCount | numberFormat}}</span>
      </app-loading-icon>
    </div>
    @if (!!visit || filters.overviewFilters.filters.crn) {
      <div class="sub-text ms-3 align-items-center d-none d-lg-flex">
        <i class="fa fa-fw fa-light fa-xl fa-weight-hanging me-1"></i>
        <app-loading-icon [loading]="appContext.useOpenSearch() ? facetsLoading : weightsLoading">
          <span>{{grossWeight | numberFormat}}</span>
        </app-loading-icon>
      </div>
    }
    <div class="sub-text ms-3 align-items-center d-none d-lg-flex">
      <i class="fa fa-fw fa-light fa-xl fa-container-storage me-1"></i>
      <app-loading-icon [loading]="facetsLoading">
        <span>{{equipmentCount | numberFormat}}</span>
      </app-loading-icon>
    </div>
  </div>

  <div class="empty-container col-12 h-100 d-flex align-items-center justify-content-center flex-column">
    <img src="/assets/new-portvisit/no-results-icon-cargo-import.svg" alt="No consignments found icon" class="mb-2"/>
    <span class="h1 mb-2">Lost at sea...</span>
    @if (filters.overviewFilters.selectedQuickView !== quickViews[0]) {
      @if (hasActiveFacetFilters) {
        <span class="text-secondary">
          <span>Try </span>
          <span class="link-primary underline-primary cursor-pointer" (click)="clearFilters(facetUtils.clearFilters(filters.overviewFilters.term))">clearing the filters</span>
          <span> or go to the </span>
          <span class="link-primary underline-primary cursor-pointer" (click)="filters.overviewFilters.selectedQuickView = quickViews[0]; facetFiltersChanged(filters.overviewFilters)">{{quickViews[0].name}}</span>
          <span> quick view</span>
        </span>
      } @else {
        <span class="text-secondary">
          <span>Try going to the </span>
          <span class="link-primary underline-primary cursor-pointer" (click)="filters.overviewFilters.selectedQuickView = quickViews[0]; facetFiltersChanged(filters.overviewFilters)">{{quickViews[0].name}}</span>
          <span> quick view</span>
        </span>
      }
      <ng-template #emptyAllRecords>
        <span class="text-secondary">
          <span>Try going to the </span>
          <span class="link-primary underline-primary cursor-pointer" (click)="filters.overviewFilters.selectedQuickView = quickViews[0]; facetFiltersChanged(filters.overviewFilters)">{{quickViews[0].name}}</span>
          <span> quick view</span>
        </span>
      </ng-template>
    } @else {
      @if (hasActiveFacetFilters) {
        <span class="text-secondary">
          <span>Try </span>
          <span class="link-primary underline-primary cursor-pointer" (click)="clearFilters(facetUtils.clearFilters(filters.overviewFilters.term))">clearing the filters</span>
        </span>
      } @else {
        <span class="text-secondary">Try adjusting your filters or search term</span>
      }
    }
    <ng-template #defaultEmptyText>
      @if (hasActiveFacetFilters) {
        <span class="text-secondary">
          <span>Try </span>
          <span class="link-primary underline-primary cursor-pointer" (click)="clearFilters(facetUtils.clearFilters(filters.overviewFilters.term))">clearing the filters</span>
        </span>
      } @else {
        <span class="text-secondary">Try adjusting your filters or search term</span>
      }
    </ng-template>
  </div>
  <div class="overview-footer position-relative">
    @if (nrOfSelectedConsignments) {
      <div class="row bg-light px-1 px-lg-3 pb-3 gy-3 border-top">
        <div class="col-12 col-md-auto col-lg d-flex align-items-center">
          <span class="sub-text me-2">
            <i class="fa fa-fw fa-light fa-xl fa-file-lines"></i>
          </span>
          <span class="d-inline-flex text-nowrap">{{nrOfSelectedConsignments}} consignment{{nrOfSelectedConsignments > 1 ? 's' : ''}}</span>
        </div>
        <div class="col ms-auto p-0"></div>
        <div class="col-12 col-sm-6 col-md-auto">
          @if (!!visit) {
            <button type="button" class="btn btn-outline-secondary me-3" (click)="openBulkUpdateTerminalModal()">Bulk update terminal</button>
          }
          <button type="button" class="btn btn-outline-secondary me-3" (click)="openBulkAddAuthorisationModal()">Bulk add authorisation</button>
          <button type="button" class="btn btn-outline-secondary" (click)="openRegisterArrivalModal()">Register arrival</button>
        </div>
      </div>
    }
  </div>
</app-overview>

<ng-template #consignmentItemTemplate let-consignment>
  <app-master-consignment-overview-item
    [consignment]="consignment" [term]="searchTerm"
    [depth]="0" [selectable]="isSelectable(consignment)"
    [selected]="isRecordSelected(consignment)"
    (selectionToggled)="toggleRecordSelection(consignment)"></app-master-consignment-overview-item>
</ng-template>

<ng-template #registerArrivalModalBody>
  <p>
    You are about to register an ata for the following consignments. This will cause these consignments to be registered to STI.
  </p>
  <ul class="row">
    @for (consignment of getSelectedConsignments(); track trackByRecord($index, consignment)) {
      <li class="col-4">
        {{consignment.masterConsignment.consignmentNumber}}
      </li>
    }
  </ul>
  <div class="row gy-4">
    <app-form-field label="Actual time of arrival" class="col-12" [(value)]="timeOfArrival">
      <app-date-field [(ngModel)]="timeOfArrival" [required]="true"></app-date-field>
    </app-form-field>
  </div>
</ng-template>

<ng-template #bulkUpdateTerminalModalBody>
  <p>
    You are about to bulk update the discharge terminal for the following consignments. This will cause the consignments to be declared on the new terminal.
  </p>
  <ul class="row">
    @for (consignment of getSelectedConsignments(); track trackByRecord($index, consignment)) {
      <li class="col-4">
        {{consignment.masterConsignment.consignmentNumber}}
      </li>
    }
  </ul>
  <div class="row gy-4">
    <app-form-field label="Terminal" class="col-12">
      <app-search [(ngModel)]="selectedTerminal" [options]="selectableTerminals" dataKey="terminalName" [required]="true"></app-search>
    </app-form-field>
  </div>
</ng-template>

<ng-template #bulkAddAuthorisationModalBody>
  <p>
    You are about to add authorisation for the given organisation to the following consignments. This will cause the consignments to be visible for that organisation.
  </p>
  <ul class="row">
    @for (consignment of getSelectedConsignments(); track trackByRecord($index, consignment)) {
      <li class="col-4">
        {{consignment.masterConsignment.consignmentNumber}}
      </li>
    }
  </ul>
  <div class="row gy-4">
    <app-form-field label="Organisation" class="col-12">
      <app-search [(ngModel)]="selectedOrganisation" [searchFunction]="utils.findBulkAuthorisations" [inputFormatter]="utils.bulkAuthorisationFormatter" [required]="true"></app-search>
    </app-form-field>
  </div>
</ng-template>

<ng-template #downloadModalBody>
  <div class="row">
    <app-form-field label="Call reference number" class="col-12" [ngClass]="!!downloadVoyageNumber ? 'd-none' : ''">
      <app-search [(ngModel)]="downloadCrn" placeholder="Search for visit" dataKey="crn"
        [required]="!downloadVoyageNumber" [inputFormatter]="utils.visitFormatter" [resultFormatter]="utils.visitFormatter"
      [minCharacters]="2" [searchFunction]="utils.findVisits" (ngModelChange)="onCrnChange($event?.crn)"></app-search>
    </app-form-field>
    <app-form-field label="Voyage number" class="col-12" [ngClass]="!!downloadCrn ? 'd-none' : ''">
      <input class="input-group form-control" [required]="!downloadCrn" [(ngModel)]="downloadVoyageNumber"/>
    </app-form-field>
    @if (appContext.isAdmin() && visit) {
      <app-form-field label="Cargo declarant" class="col-12">
        <app-search [(ngModel)]="selectedDeclarant" [options]="visit.cargoDeclarants" dataKey="fullName"></app-search>
      </app-form-field>
    }
  </div>
</ng-template>

<ng-template #downloadMrnModalBody>
  <div class="row">
    <app-form-field label="Call reference number" class="col-12" [ngClass]="!!downloadVoyageNumber ? 'd-none' : ''">
      <app-search [(ngModel)]="downloadCrn" placeholder="Search for visit" dataKey="crn"
        [required]="!downloadVoyageNumber" [inputFormatter]="utils.visitFormatter" [resultFormatter]="utils.visitFormatter"
      [minCharacters]="2" [searchFunction]="utils.findVisits" (ngModelChange)="onCrnChange($event?.crn)"></app-search>
    </app-form-field>
    <app-form-field label="Voyage number" class="col-12" [ngClass]="!!downloadCrn ? 'd-none' : ''">
      <input class="input-group form-control" [required]="!downloadCrn" [(ngModel)]="downloadVoyageNumber"/>
    </app-form-field>
    @if (appContext.isAdmin() && visit) {
      <app-form-field label="Cargo declarant" class="col-12">
        <app-search [(ngModel)]="selectedDeclarant" [options]="visit.cargoDeclarants" dataKey="fullName"></app-search>
      </app-form-field>
    }
  </div>
</ng-template>

<ng-template #downloadZhsModal>
  <div class="row gx-0">
    <div class="col-12 mb-3">
      Download an overview of inbound and outbound cargo flows. The cargo from all participating cargo handling agents is included. The overview is anonymised and aggregated. Including HS chapters, ports of loading and discharge, total volume and amount of containers.
    </div>
    <app-form-field label="Cargo type" class="col-12">
      <app-yes-no [(ngModel)]="downloadZhsBulkData" required [formatter]="bulkDataFormatter"></app-yes-no>
    </app-form-field>
    <app-form-field label="Date range" class="col-12">
      <app-date-range [(ngModel)]="downloadZhsDateRange" required [dateOnly]="true"></app-date-range>
    </app-form-field>
  </div>
</ng-template>

<div id="declareTranshipmentContainerConsignment" class="modal modal-lg fade" role="dialog" tabindex="-1"
     style="z-index: 10000">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <app-declare-transhipment-container-consignment></app-declare-transhipment-container-consignment>
    </div>
  </div>
</div>

<div id="declareTranshipmentBulkConsignment" class="modal modal-lg fade" role="dialog" tabindex="-1"
     style="z-index: 10000">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <app-declare-transhipment-bulk-consignment></app-declare-transhipment-bulk-consignment>
    </div>
  </div>
</div>

<ng-template #specificFacetFilters>
  <div class="col-12">
    <app-facet-date-range [ranges]="ranges" [filterName]="'Last updated'" (ngModelChange)="declarationDateChanged($event)"
                          [(ngModel)]="filters.overviewFilters.filters.timeRange"
                          [removable]="false" [filterDisabled]="!!filters.overviewFilters.term"></app-facet-date-range>
  </div>
  <div class="col-12">
    <app-facet-filter-search-field
      [filterName]="'Call reference number'" [inputFormatter]="utils.visitFormatterExtended" [searchFunction]="findVisits"
      [value]="filters.overviewFilters.filters.crn" dataKey="crn" (valueSelected)="crnFilterChanged($event)"
      [selectedValueFormatter]="crnFilterValueFormatter"></app-facet-filter-search-field>
  </div>
</ng-template>

<ng-template #allRecordsNoFilters>
  <span class="text-secondary">Try adjusting your filters or search term</span>
</ng-template>
